import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import Error from 'components/Error';
import ToggleSwitch from 'components/form-components/ToggleSwitch';
import FormButton from 'components/form-components/FormButton';
import FormLoadingButton from 'components/form-components/FormLoadingButton';
import { CallAPI } from 'actions/General';

const AttendanceSettings = ({ companyDetails, getCompanyDetail }) => {
  const { t } = useTranslation();
  const [values, setValues] = useState({ attendanceMediaRequired: false });
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState('');

  useEffect(() => {
    setValues({ attendanceMediaRequired: companyDetails?.attendanceMediaRequired ?? false });
  }, [companyDetails]);

  const handleChange = (field, value) => {
    setValues({ ...values, [field]: value });
  };

  const submit = async () => {
    const payload = { attendanceMediaRequired: values.attendanceMediaRequired };
    const result = await CallAPI('UPDATE_COMPANY_DETAIL', payload, null, setLoading, setApiError);

    if (result.status) {
      toast.success(t('alert_operation_completed_successfully'));
      getCompanyDetail();
    }
  };

  return (
    <>
      <div className='px-4 py-3'>
        {apiError && (
          <div className='mb-2'>
            <Error msg={apiError} />
          </div>
        )}
        <div className='d-flex align-items-center gap-3'>
          <label className='min-width-176'>{t('field_require_user_attendance_media')}</label>
          <ToggleSwitch
            name='attendanceMediaRequired'
            value={values.attendanceMediaRequired}
            handleChange={handleChange}
          />
        </div>
        <div className='mt-3  w-100 d-flex justify-content-end gap-3'>
          <FormButton text='button_cancel' variant='white-1' />
          <FormLoadingButton
            onClick={submit}
            loading={loading}
            text='button_save'
            variant='green-1'
          />
        </div>
      </div>
    </>
  );
};

AttendanceSettings.propTypes = {
  companyDetails: PropTypes.object,
  getCompanyDetail: PropTypes.func.isRequired,
};

export default AttendanceSettings;
